import theme from '../../../constants/theme';
export const Style = ({
    img: {
        width: 14,
        height: 14
    }
});
